import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite} from "gsap";
import {TeslaGameAssets} from "../../TeslaGameAssets";
import {TeslaGameConfig} from "../../TeslaGameConfig";

/**
 * Created by h3 on 2017-11-01.
 */

export class BackgroundWindow extends BaseView {

    private _layer:ScalableLayer;
    private _windowAnimation:TimelineSprite;
    private _lightningEffect:TimelineSprite;
    private _windowTopFrame:PIXI.Sprite;

    constructor(resourcesGroup:ResourcesGroupName) {
        super(resourcesGroup);
        this._layer = StageManager.getLayer(TeslaGameConfig.instance.LAYERS.BACKGROUND.name);
    }

    protected initAnimations():void {

        this._lightningEffect = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.LIGHTNING_EFFECT));
        this._lightningEffect.anchor.set(0.135, 0.445);
        this._lightningEffect.position.set(157, 252);
        this._lightningEffect.scale.set(0.36, 0.5);
        this._lightningEffect.rotation = 62 * PIXI.DEG_TO_RAD;
        this._lightningEffect.blendMode = PIXI.BLEND_MODES.ADD;
        this._lightningEffect.hide();
        this._layer.addChild(this._lightningEffect);


        this._windowTopFrame = new PIXI.Sprite(GameResources.getTextures(TeslaGameAssets.WINDOW_TOP_FRAME)[0]);
        this._windowTopFrame.anchor.set(0.5, 0.5);
        this._windowTopFrame.position.set(196, 263);
        this._layer.addChild(this._windowTopFrame);
        this._windowAnimation = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.BACKGROUND_WINDOW));
        this._windowAnimation.position.set(111, 279);
        this._layer.addChild(this._windowAnimation);

    }

    public getWindowLightning():TimelineLite {

        const tl:TimelineLite = new TimelineLite();
        tl.add(() => this._lightningEffect.show());
        tl.add(this._lightningEffect.getAnimation());
        tl.add(() => this._lightningEffect.hide());
        return tl;

    }

    public resetView():TimelineLite {
        return this.resetWindowAnimation();
    }

    private resetWindowAnimation() {
        const tl:TimelineLite = new TimelineLite();
        const currentFrame = this._windowAnimation.currentFrame;
        tl.add(this._windowAnimation.getAnimation([currentFrame, 0]));
        tl.add(() => this._lightningEffect.hide());
        return tl;
    }

    public getAnimation():TimelineLite {
        return this.createWindowAnimation();
    }

    private createWindowAnimation() {
        const tl:TimelineLite = new TimelineLite();
        const currentFrame = this._windowAnimation.currentFrame;
        tl.timeScale(1);
        tl.add(this._windowAnimation.getAnimation([currentFrame, 6]));
        tl.timeScale(0.4);
        tl.add(this._windowAnimation.getAnimation([6, 15]));
        tl.add(this._windowAnimation.getAnimation([0, 6]));

        return tl;
    }
}

